export const getHeader = () => {
	return { Authorization: process.env.REACT_APP_SITE_KEY };
};

export const getHeaderWithToken = token => {
	let AUTH_HEADER = getHeader();

	if (token) {
		AUTH_HEADER.Authorization += ":Bearer " + token;
	}

	return AUTH_HEADER;
};

export const getAuthHeader = (user, isAdmin = false) => {
	let AUTH_HEADER = getHeader();

	// Get user token
	let token = "";

	if (isAdmin) {
		token = !!user.admin ? user.admin.token : null;
	} else {
		token = !!user.reviewer ? user.reviewer.token : null;
	}

	AUTH_HEADER.Authorization += ":Bearer " + token;

	return AUTH_HEADER;
};



// WEBPACK FOOTER //
// ./src/store/headers.js